import React from 'react';
import { useIntl } from 'react-intl';

import styles from './ActiveUsersCount.scss';
import UsersIcon from './assets/users-icon.svg';

export interface Props {
  count: number;
}

const ActiveUsersCount: React.FC<Props> = ({ count }) => {
  const { formatNumber } = useIntl();

  return (
    <div className={styles.container}>
      <UsersIcon />
      {formatNumber(count, { style: 'decimal' })}
    </div>
  );
};

export default ActiveUsersCount;
